import React, { useContext } from 'react';
import { Switch, Route } from "react-router-dom";
import { BodyContext } from '~/context/BodyContext.js'
import { PrivateRoute } from './PrivateRoute'
import C from '~/components'
// 
import Home from '~/pages/guest/Home.jsx'
// 

const R_User = props => {
    const [setting] = useContext(BodyContext);
    const base_path = props.match.path;
    return (
        <div className={"route " + setting.classing.route}>
            <div className="page">
                <div className="c-">
                    <C.Navbar />
                    {/* <Titlebar /> */}
                    <C.Content>
                        User
                    </C.Content>
                </div>
            </div>
        </div>
    );
}
const R_Guest = props => {
    const [setting] = useContext(BodyContext);
    const base_path = props.match.path === '/' ? '' : props.match.path;
    return (
        <div className={"route " + setting.classing.route}>
            <div className="page">
                <div className="c-">
                    <C.Navbar />
                    {/* <Titlebar /> */}
                    <C.Content>
                        <Switch>
                            <Route exact path={`${base_path}/`} component={Home} />
                            {setting.authRedirection}
                        </Switch>
                    </C.Content>
                </div>
            </div>
        </div>
    );
}
const R_Admin = props => {
    const [setting] = useContext(BodyContext);
    return (
        <div className={"route " + setting.route}>
            <div className="page">
                <div className="c-">
                    <C.Content>
                        Admin
                    </C.Content>
                </div>
            </div>
        </div>
    );
}

const Routing = {}
Routing.user = R_User;
Routing.guest = R_Guest;
Routing.admin = R_Admin;
export default Routing;